<div class="profile-loader-container">
  <div class="profile-loader-content">
    @if (loading) {
      <div class="loading-section">
        <p-progressSpinner 
          styleClass="w-4rem h-4rem" 
          strokeWidth="4" 
          fill="transparent">
        </p-progressSpinner>
        <h2>Loading your profile...</h2>
        <p>Please wait while we set up your workspace</p>
      </div>
    }

    @if (error) {
      <div class="error-section">
        <div class="error-icon">
          <i class="pi pi-exclamation-triangle"></i>
        </div>
        <h2>Profile Loading Failed</h2>
        <p class="error-message">{{ errorMessage }}</p>
        
        <div class="error-actions">
          <p-button 
            label="Try Again" 
            icon="pi pi-refresh"
            (click)="retry()"
            [loading]="loading">
          </p-button>
        </div>
      </div>
    }
  </div>
</div>